import m, {Vnode} from "mithril";
import MaxDiffState, {TMaxDiffRow} from "../MaxDiffState";
import MaxDiff from "../MaxDiff";

export default class MaxDiffDefault extends MaxDiff {

    private viewScale(): Vnode {
        const questionary = this.settings.form.questionary;
        return m('.scale', {}, [
            m('label', {}, questionary.renderText(this.winLabel.label ?? '')),
            this.state.isFinalRound() ? null : m('label', {}, questionary.renderText(this.loseLabel.label ?? '')),
        ]);
    }

    private viewTable(): Vnode {
        return m('table', {}, this.state.getCurrentRows().map(row => this.viewRow(row)));
    }

    private viewRow(row: TMaxDiffRow): Vnode {
        const questionary = this.settings.form.questionary;
        const x = row.label?.cell.row;
        return m('tr', {}, [
            m('td',
                m('label',
                    m(`input[type="radio"][name="win"][value="${x}"]`, {
                        onclick: () => this.state.setValue(row, MaxDiffState.RATING_WIN),
                        checked: row.ratings[this.state.round].getVariable() === MaxDiffState.RATING_WIN,
                    })
                )
            ),
            m('td', {}, [
                row.image ? m(row.image) : null,
                row.label ? m('label', {}, questionary.renderText(row.label.label ?? '')) : null,
            ]),
            m('td',
                m('label',
                    this.state.isFinalRound() ? null : m(`input[type="radio"][name="lose"][value="${x}"]`, {
                        onclick: () => this.state.setValue(row, MaxDiffState.RATING_LOSE),
                        checked: row.ratings[this.state.round].getVariable() === MaxDiffState.RATING_LOSE,
                    })
                )
            ),
        ])
    }


    public view(): Vnode {
        return this.viewLayout(
            m('.MaxDiff', {}, [
                this.viewScale(),
                this.viewTable(),
                this.viewProgress(),
            ])
        );
    }
}